import EformBaseService from '../../../../services/EformBaseService'

export default class TestformularService extends EformBaseService {

  constructor() {
    super('wbf/isceco/testformular')
  }

}
